
/**
 * 课程中心
 */

 export const CourseList=[
    {
        prop:"title",
        label:"课程标题",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"teacherName",
        label:"讲师",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"courseCategoryName",
        label:"分类",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"type",
        label:"公开范围",
        width:"150",
        format: "type",
        order: false,
        isShow:true
    },
    {
        prop:"watchNumber",
        label:"播放数",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"tasgNumber",
        label:"点赞数",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"status",
        label:"状态",
        width:"150",
        format: "status",
        order: false,
        isShow:true
    },
    {
        prop:"isGoodClass",
        label:"是否好课",
        width:"150",
        format: "isGoodClass",
        order: false,
        isShow:true
    },
    {
        prop: "creationTime",
        label: "创建时间",
        width: "200",
        format: "datetime",
        order: true,
        isShow: true
    },
    {
        prop: "lastModificationTime",
        label: "最后修改时间",
        width: "200",
        format: "datetime",
        order: true,
        isShow: true
    }
 ]

